export interface Permissions {
  can_edit_knowledge_base: boolean;
  can_send_messages: boolean;
  can_approve_agent_replies: boolean;
  can_react_to_agent_messages: boolean;
  can_assign_escalate_dialogs: boolean;
  can_view_agent_runs: boolean;
  can_invite_users: boolean;
  can_view_chats?: boolean;
  can_view_crm?: boolean;
  can_use_playground?: boolean;
  can_view_remarks?: boolean;
  can_manage_users?: boolean;
}

export interface LoginUser {
  id: string;
  name: string;
  email: string;
  role_key: string;
  permissions: Permissions;
  locale?: string;
}

export interface LoginResponse {
  token: string;
  expires_at: string;
  user: LoginUser;
}

export interface AuthSession {
  token: string;
  expiresAt: string;
  user: LoginUser;
}

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
